import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const LOCAL_STORAGE_KEY = 'slang';
const initCurrentLang = localStorage.getItem(LOCAL_STORAGE_KEY) || 'id';

i18n.use(initReactI18next).init({
    fallbackLng: initCurrentLang,
    debug: true,
    interpolation: {
        escapeValue: false,
    },
    resources: {},
});

export default i18n;
